/**
 * Плагин: при ресайзе узла обновляем path (hexagon/grouping/note) или иконку (rect).
 */
import {PATH_BASED_SHAPES} from '../modelerX6/constants';

export default {
	init(modeler, context) {
		const {graph} = context;

		const onNodeResize = args => {
			const cell = args?.cell ?? args?.node ?? args;
			if (!cell || typeof cell.isNode !== 'function' || !cell.isNode()) return;
			const shapeId = typeof cell.getShape === 'function' ? cell.getShape() : cell.shape;
			if (PATH_BASED_SHAPES.includes(shapeId)) {
				modeler._nodeFactory.update(cell);
			} else {
				modeler._nodeFactory.refreshIcon(cell);
			}
		};

		graph.on('node:change:size', onNodeResize);
		graph.on('cell:change:size', onNodeResize);

		return () => {
			graph.off('node:change:size', onNodeResize);
			graph.off('cell:change:size', onNodeResize);
		};
	},
};
